import { fetcher } from '@commenda/utils';
import { readServingRuleError } from './readServingRuleError';
import {
  BatchCreateLocationServingRulesResponse,
  ServingRuleItem,
} from './types';

export async function createLocationServingRules(
  locationId: string,
  body: { serving_rules: ServingRuleItem[] }
): Promise<{
  success: boolean;
  data?: BatchCreateLocationServingRulesResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/locations/${locationId}/serving-rules`,
      { method: 'POST', body }
    );

    if (!response.ok) {
      return {
        success: false,
        error: await readServingRuleError(
          response,
          'Failed to add serving rule'
        ),
      };
    }

    const data =
      (await response.json()) as BatchCreateLocationServingRulesResponse;

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to add serving rule',
    };
  }
}
